export enum ActionName {
    EDIT = 'edit',
    DUPLICATE = 'duplicate',
    ARCHIVE = 'archive',
    ACTIVATE = 'activate',
    RESTORE = 'restore',
    REMOVE = 'remove',
    DELETE = 'delete',
    CONVERT_TO_TEMPLATE = 'convertToTemplate',
    VIEW = 'view',
    REQUEST_ACCESS = 'requestAccess'
}
